import { InsightCatalogue } from '../InsightCatalogue';
import {
  FullInsightPayload,
  InsightMetric,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface RequestsDeclinedPayload extends FullInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_REQUESTS_DECLINED;
    id: string;
    attributes: {
      data: Array<{
        declination_reason: string;
        request_count: number;
      }>;
      aggregate: {
        declined_requests: InsightMetric;
      };
    };
  };
}

export const parseRequestsDeclinedPayload = (
  payload: BaseInsightPayload
): RequestsDeclinedPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_REQUESTS_DECLINED,
    data.attributes,
    true,
    true,
    ['declined_requests']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{ declination_reason: string; request_count: number }>;
    aggregate: { declined_requests: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_REQUESTS_DECLINED,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
        aggregate: {
          declined_requests: typedAttributes.aggregate.declined_requests,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
